import { render, staticRenderFns } from "./channel-reserve-detail-drawer.vue?vue&type=template&id=992e51b8&scoped=true"
import script from "./channel-reserve-detail-drawer.vue?vue&type=script&lang=js"
export * from "./channel-reserve-detail-drawer.vue?vue&type=script&lang=js"
import style0 from "./channel-reserve-detail-drawer.vue?vue&type=style&index=0&id=992e51b8&prod&scoped=true&lang=css"
import style1 from "./channel-reserve-detail-drawer.vue?vue&type=style&index=1&id=992e51b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992e51b8",
  null
  
)

export default component.exports